import {
  GetChallengeByUUIDResponse,
  GetChallengeMetricsResponse,
  GetChallengesItemResponse,
  GetChallengesResponse,
  PostChallengeResponse,
  PutChallengeResponse,
} from '@/services/response/challenge';
import { Challenge } from '@/model/challenge';
import { ChallengeMetrics } from '@/model';

export class ChallengeConverter {
  static toDomainFromChallengeItemResponse(response: GetChallengesItemResponse): Challenge {
    return {
      uuid: response.uuid,
      status: response.status,
      interactivity: response.interactivity,
      title: response.title,
      time_limit_seconds: response.time_limit_seconds,
      description: response.description,
      timeout_message: response.timeout_message,
      error_message: response.error_message,
      winner_message: response.winner_message,
      communication_message: response.communication_message,
      starts_in: response.starts_in,
      question_count: response.question_count,
      total_participants: response.total_participants,
      created_at: response.created_at,
      updated_at: response.updated_at,
      questions: response.questions ?? [],
      challengeParticipation: response.challengeParticipation ?? [],
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      winner: response.winner
        ? {
            uuid: response.winner.uuid,
            display_name: response.winner.display_name,
            avatar_url: response.winner.avatar_url ?? null,
            total_correct: response.winner.total_correct,
            total_time_seconds: response.winner.total_time_seconds,
          }
        : undefined,
    };
  }

  static toDomainFromChallengesPaginatedResponse(response: GetChallengesResponse): Challenge[] {
    return response.data.map(ChallengeConverter.toDomainFromChallengeItemResponse);
  }

  static toDomainFromGetChallengeByUUIDResponse(response: GetChallengeByUUIDResponse): Challenge {
    return {
      uuid: response.uuid,
      status: response.status,
      interactivity: response.interactivity,
      title: response.title,
      time_limit_seconds: response.time_limit_seconds,
      description: response.description,
      timeout_message: response.timeout_message,
      error_message: response.error_message,
      winner_message: response.winner_message,
      communication_message: response.communication_message,
      starts_in: response.starts_in,
      question_count: response.question_count,
      total_participants: response.total_participants,
      created_at: response.created_at,
      updated_at: response.updated_at,
      questions: response.questions ?? [],
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      challengeParticipation: response.challengeParticipation ?? [],
    };
  }

  static toDomainFromPostChallengeResponse(response: PostChallengeResponse): Challenge {
    return {
      uuid: response.uuid,
      status: response.status,
      interactivity: response.interactivity,
      title: response.title,
      time_limit_seconds: response.time_limit_seconds,
      description: response.description,
      timeout_message: response.timeout_message,
      error_message: response.error_message,
      winner_message: response.winner_message,
      communication_message: response.communication_message,
      starts_in: response.starts_in,
      question_count: response.question_count,
      total_participants: response.total_participants,
      created_at: response.created_at,
      updated_at: response.updated_at,
      questions: response.questions ?? [],
      challengeParticipation: response.challengeParticipation ?? [],
    };
  }

  static toDomainFromPutChallengeResponse(response: PutChallengeResponse): Challenge {
    return {
      uuid: response.uuid,
      status: response.status,
      interactivity: response.interactivity,
      title: response.title,
      time_limit_seconds: response.time_limit_seconds,
      description: response.description,
      timeout_message: response.timeout_message,
      error_message: response.error_message,
      winner_message: response.winner_message,
      communication_message: response.communication_message,
      starts_in: response.starts_in,
      question_count: response.question_count,
      total_participants: response.total_participants,
      created_at: response.created_at,
      updated_at: response.updated_at,
      questions: response.questions ?? [],
      challengeParticipation: response.challengeParticipation ?? [],
    };
  }

  static toDomainFromGetChallengeMetricsResponse(response: GetChallengeMetricsResponse): ChallengeMetrics {
    return {
      total_participants: response.total_participants,
      winners: response.winners,
      challenges: response.challenges,
    };
  }
}
